import { Routes, Route, Navigate } from 'react-router-dom';
import './admin.css';

import AdminLogin from './pages/AdminLogin';
import AdminLayout from './layouts/AdminLayout';
import Dashboard from './pages/Dashboard';
import Tenants from './pages/Tenants';
import Landlords from './pages/Landlords';
import LandlordProperties from './pages/LandlordProperties';
import Questions from './pages/Questions';
import Discounts from './pages/Discounts';
import Revenue from './pages/Revenue';
import Settings from './pages/settings/Settings';
import Profile from './pages/settings/Profile';
import ChangePassword from './pages/settings/ChangePassword';

export default function AdminRoutes() {
  return (
    <Routes>
      <Route index element={<AdminLogin />} />
      <Route path="dashboard" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="tenants" element={<Tenants />} />
        <Route path="landlords" element={<Landlords />} />
        <Route path="landlords/:id/properties" element={<LandlordProperties />} />
        <Route path="questions" element={<Questions />} />
        <Route path="discounts" element={<Discounts />} />
        <Route path="revenue" element={<Revenue />} />
        <Route path="settings" element={<Settings />}>
          <Route index element={<Profile />} />
          <Route path="change-password" element={<ChangePassword />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}
